import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { PixPaymentKeyService } from '../../payment-key.service';
import { PixPaymentFavoredView } from '../../../models/payment-favored-view.model';
import { PixKeyType } from '../../../models/key-type.enum';
import { Util } from '../../../../../utils/util';
import { SharedService } from '../../../../../shared/shared.service';
import { AppEventDispatcher } from '../../../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../../../shared/EventTypes';

@Component({
	selector: 'app-pix-payment-key-favored-create-value-date',
	templateUrl: './value-date.component.html',
	styleUrls: ['./value-date.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixPaymentKeyFavoredCreateValueAndDateComponent implements OnInit {

	public form: FormGroup;
	public submited = false;
	public minDate = new Date(new Date());
	public maxDate = this.nextYear
	public selectedPixPaymentFavoredView: PixPaymentFavoredView;
	public saldoParcial = 0;
	public saldoSaque = 0;
	public limiteDisponivel = 0;
	public showBalanceLimit = false;

	constructor(
		private formBuilder: FormBuilder,
		private router: Router,
		public dialog: MatDialog,
		private pixPaymentKeyService: PixPaymentKeyService,
		private sharedService: SharedService,
	) { }

	get nextYear() {
		const today = new Date();
		return new Date(today.setFullYear(today.getFullYear() + 1))
	}

	get transactionValue() {
		if (this.selectedPixPaymentFavoredView.valorQrCode) {
			return this.selectedPixPaymentFavoredView.valorQrCode;
		}

		if (this.selectedPixPaymentFavoredView.valorTransferir) {
			return this.selectedPixPaymentFavoredView.valorTransferir;
		}

		return 0;
	}

	ngOnInit(): void {
		this.selectedPixPaymentFavoredView = this.pixPaymentKeyService.getSelectedPixPaymentFavoredView();

		if (this.invalidParams()) {
			this.goBack();
		}

		this.buildForm();
		this.getBalance();
	}

	getBalance() {
		this.sharedService.getBalance().subscribe((data: any) => {
			this.saldoSaque = data.Retorno.SaldoSaque;
			this.saldoParcial = data.Retorno.SaldoParcial;
			this.limiteDisponivel = data.Retorno.LimiteDisponivel;
		},
			(error) => {
				this.handleError(error);
				this.router.navigate(['/']);
			}
		);
	}

	buildForm() {
		const value = this.transactionValue
		const date = new Date();

		this.form = this.formBuilder.group({
			name: this.getName(),
			value: [value == 0 ? '' : value, [Validators.required, Validators.min(0.01), Validators.max(999999999)]],
			date: [date, Validators.required],
			description: ['', [Validators.pattern(Util.allowedCharactersRegex), Validators.maxLength(100)]]
		});

		if (this.selectedPixPaymentFavoredView && this.selectedPixPaymentFavoredView.valorQrCode > 0) {
			this.form.get('value').disable();
		}

	}

	invalidParams(): boolean {
		return this.selectedPixPaymentFavoredView === undefined ||
			this.selectedPixPaymentFavoredView.tipoChave === undefined ||
			(this.selectedPixPaymentFavoredView.tipoChave !== PixKeyType.MANUAL && this.selectedPixPaymentFavoredView.codigo === undefined) ||
			(this.selectedPixPaymentFavoredView.tipoChave === PixKeyType.MANUAL && this.selectedPixPaymentFavoredView.numeroAgencia === undefined || this.selectedPixPaymentFavoredView.numeroConta === undefined);
	}

	submit() {
		if (this.form.valid) {
			this.selectedPixPaymentFavoredView.valorTransferir = this.form.get('value').value;
			this.selectedPixPaymentFavoredView.descricaoTransferir = this.form.get('description').value;
			this.selectedPixPaymentFavoredView.dataTransferir = new Date(this.form.get('date').value);
			this.pixPaymentKeyService.setSelectedPixPaymentFavoredView(this.selectedPixPaymentFavoredView);

			this.router.navigate(['pix/pagamento/favorecido/adicionar/resumo']);
		}
	}

	verifyZero() {
		if ($('.currency-field').val() === '0,00') {
			$('.currency-field').val('');
		}
	}

	showInfoSaldo(): boolean {
		const availableBalance = this.availableBalanceValue();
		const value = this.inputValue();

		this.showBalanceLimit = false;
		if (availableBalance + this.limiteDisponivel >= value) {
			this.showBalanceLimit = true;
		}

		return (value > availableBalance && !this.showBalanceLimit);
	}

	getTextSaldo(): string {
		this.showBalanceLimit = false;
		return `Você não possui saldo disponível para realizar este pagamento`;
	}

	showInfoSaldoLimiteOmniPlus(): boolean {
		const availableBalance = this.availableBalanceValue();
		const inputValue = this.inputValue();

		if (inputValue > availableBalance || this.limiteDisponivel > 0) {
			if (availableBalance < inputValue) {
				return availableBalance + this.limiteDisponivel >= inputValue && this.limiteDisponivel > 0;
			}
		}
		return false;
	}

	getTextSaldoLimiteOmniPlus(): string {
		this.showBalanceLimit = true;
		return `Nesta operação você utilizará <b>${this.getLimitValue()}</b> do seu <b>Limite Omni Plus</b> e estará sujeito a cobrança de encargos proporcionais aos dias de uso do limite.`;
	}

	getLimitValue(): string {
		const availableBalance = this.availableBalanceValue();
		const inputValue = this.inputValue();
		return Util.formatValue(inputValue - availableBalance);
	}

	availableBalanceValue(): number {
		return this.saldoParcial >= 0 ? this.saldoParcial : 0;
	}

	inputValue(): number {
		return this.form.get('value').value;
	}

	goBack = () => this.router.navigate(['pix/pagamento/']);
	goNext = () => this.router.navigate(['pix/pagamento/favorecido/adicionar']);
	getName = () => this.selectedPixPaymentFavoredView === undefined ? '' : this.selectedPixPaymentFavoredView.nome;

	handleError = (error) => AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
}


// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/payment-key/favored-create/value-date/value-date.component.ts